import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from '../accordion/accordion.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { DateRangeModule } from '../date-range/date-range.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmergencyContactComponent } from './emergency-contact.component';
import { InputSubmitModule } from '../input-submit/input-submit.module';



@NgModule({
  declarations: [EmergencyContactComponent],
  imports: [
    CommonModule,
    AccordionModule,
    InputFieldModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InputSelectModule,
    DateRangeModule,
    InputSubmitModule
  ],
  exports: [EmergencyContactComponent]
})
export class EmergencyContactModule { }
